export default {
  MEDIA: {
    BASE: 'http://analog.com/media/en',
    SUPPORTED: {
      DS: 'technical-documentation/data-sheets',
      AN: 'technical-documentation/application-notes',
      CN: 'reference-design-documentation/reference-designs',
    },
  },
};
